import React from "react";

const STATUS_STYLES = {
  pending: {
    borderColor: "#faad14",
    backgroundColor: "#fffbe6",
    titleColor: "#ad6800",
  },
  completed: {
    borderColor: "#52c41a",
    backgroundColor: "#f6ffed",
    titleColor: "#237804",
  },
  failed: {
    borderColor: "#ff4d4f",
    backgroundColor: "#fff2f0",
    titleColor: "#a8071a",
  },
};

const formatDateTime = (value) => {
  if (!value) {
    return null;
  }

  const parsed = new Date(value);

  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  return parsed.toLocaleString("es-CL");
};

const formatDuration = (sync) => {
  if (!sync) {
    return null;
  }

  if (sync.executionTime) {
    return sync.executionTime;
  }

  if (typeof sync.durationMs !== "number" || Number.isNaN(sync.durationMs)) {
    return null;
  }

  const seconds = Math.round(sync.durationMs / 1000);
  const minutes = Math.round(seconds / 60);
  return `[${seconds} - SEG]/[${minutes} - MIN]`;
};

function PyramidSyncStatusNotice({ sync }) {
  if (!sync?.status) {
    return null;
  }

  const currentStyle = STATUS_STYLES[sync.status] ?? STATUS_STYLES.pending;
  const startedAt = formatDateTime(sync.startedAt);
  const finishedAt = formatDateTime(sync.finishedAt);
  const duration = formatDuration(sync);

  return (
    <div
      style={{
        marginBottom: "24px",
        padding: "16px",
        border: `1px solid ${currentStyle.borderColor}`,
        backgroundColor: currentStyle.backgroundColor,
        borderRadius: "8px",
      }}
    >
      <div
        style={{
          color: currentStyle.titleColor,
          fontSize: "16px",
          fontWeight: 700,
          marginBottom: "8px",
        }}
      >
        Estado sincronizacion de permisos
      </div>
      <div style={{ marginBottom: "8px" }}>{sync.message}</div>
      <div style={{ display: "grid", gap: "4px", fontSize: "14px" }}>
        <div>
          <strong>Estado:</strong> {sync.status}
        </div>
        {sync.executionId ? (
          <div>
            <strong>Execution ID:</strong> {sync.executionId}
          </div>
        ) : null}
        {startedAt ? (
          <div>
            <strong>Inicio:</strong> {startedAt}
          </div>
        ) : null}
        {finishedAt ? (
          <div>
            <strong>Fin:</strong> {finishedAt}
          </div>
        ) : null}
        {duration ? (
          <div>
            <strong>Duracion:</strong> {duration}
          </div>
        ) : null}
        {typeof sync.requestClassificationsProcessed === "number" ? (
          <div>
            <strong>Clasificaciones procesadas:</strong>{" "}
            {sync.requestClassificationsProcessed}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default PyramidSyncStatusNotice;
